import APIService from "../../Service/APIService";

// THE SEAM (D7). Stage 4 (Stage 4 §8 of plans/AABI-Manufacturer-Drill-Down.md): the
// mock module is gone and every function talks to the real AABI endpoints. Each one
// returns the unwrapped `data` object so components never touch the transport
// envelope (§5.2 rule 2).

// Runtime normalization boundary (§8.7): only endpoint-supported parameters
// are serialized — display-only values such as `manufacturerName` never reach
// a real endpoint, and every param is coerced to a string safely.
const ENDPOINT_PARAMS = {
  drilldown: [
    "level",
    "categoryId",
    "groupId",
    "productId",
    "startDate",
    "endDate",
    "compareStartDate",
    "compareEndDate",
  ],
  top: [
    "dimension",
    "categoryId",
    "groupId",
    "productId",
    "startDate",
    "endDate",
    "compareStartDate",
    "compareEndDate",
    "limit",
    "offset",
  ],
  trend: [
    "categoryId",
    "groupId",
    "productId",
    "startDate",
    "endDate",
    "compareStartDate",
    "compareEndDate",
    "granularity",
  ],
};

const toQuery = (endpoint, params) => {
  const allowed = ENDPOINT_PARAMS[endpoint];
  const query = new URLSearchParams();
  Object.entries(params || {}).forEach(([key, value]) => {
    if (value === undefined || value === null || value === "") return;
    if (allowed && !allowed.includes(key)) return;
    query.set(key, String(value));
  });
  return query.toString();
};

// Both real-mode calls return the unwrapped `data` object (never
// `response.data.data`) so components never touch the envelope (§5.2 rule 2).
const unwrap = async (requestPromise) => {
  const response = await requestPromise;
  return response?.data?.data;
};

export const fetchDrillDown = async (params) =>
  unwrap(
    new APIService().getDataFromBackend(
      `aabi/manufacturer/${params.manufacturerId}/drilldown?${toQuery(
        "drilldown",
        params,
      )}`,
    ),
  );

export const fetchTopEntities = async (params) =>
  unwrap(
    new APIService().getDataFromBackend(
      `aabi/manufacturer/${params.manufacturerId}/top?${toQuery("top", params)}`,
    ),
  );

// §8.2: the trend endpoint returns aligned current/prior series (≤30 buckets
// under `granularity=auto`) and unwraps the transport envelope exactly like
// the other AABI functions.
export const fetchTrend = async (params) =>
  unwrap(
    new APIService().getDataFromBackend(
      `aabi/manufacturer/${params.manufacturerId}/trend?${toQuery(
        "trend",
        params,
      )}`,
    ),
  );
